import axios, { AxiosInstance } from 'axios';
import { PronunciationResponse } from './model/pronunciationResponse';
import { PronunciationFilters } from './model/pronunciation-filters.dto';
import { ListenPronunciationResponseDto } from './model/listePronunciationResponse';

const API_URL = process.env.REACT_APP_API_URL;
const PRONUNCIATIONS_URL = (projectId: string, rest = '') =>
  `${API_URL}/projects/${projectId}/pronunciations${rest}`;
const PRONUNCIATION_LISTEN_URL = (projectId: string, pronunciationId: string) =>
  PRONUNCIATIONS_URL(projectId, `/${pronunciationId}/listen`);

export async function getPronunciations(
  projectId: string,
  axiosInstance: AxiosInstance = axios.create(),
  filters?: PronunciationFilters,
): Promise<PronunciationResponse[]> {
  const response = await axiosInstance.get(PRONUNCIATIONS_URL(projectId), {
    params: filters,
  });
  return response.data;
}

export async function listenPronunciation(
  projectId: string,
  pronunciationId: string,
  axiosInstance: AxiosInstance = axios.create(),
): Promise<ListenPronunciationResponseDto> {
  const response = await axiosInstance.get(
    PRONUNCIATION_LISTEN_URL(projectId, pronunciationId),
  );
  return response.data;
}
